// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2yHIa","empty":"ModalGraph_empty__3iN3g"};